import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Observable, of } from 'rxjs';
import { environment } from '../../environments/environment';
import {
  CompanyPin,
  MonthlyCostCalculationParams,
  MonthlyCostInfo,
} from '../models';

@Injectable({
  providedIn: 'root',
})
export class CalculatorService {
  readonly apiUrl = `${environment.legacyApi.host}/portal_api/quick_cost`;
  readonly cookieExpirationTime = 7;
  readonly cookieName = 'calculatorPin';
  readonly headers = { 'Content-Type': 'application/json' };

  constructor(private http: HttpClient, private cookie: CookieService) {}

  validatePin(payload: CompanyPin): Observable<any> {
    return this.http.get(`${this.apiUrl}/validate_contractor_pin`, {
      headers: this.headers,
      params: { pin: payload.pin },
    });
  }

  calculateMonthlyCost(
    payload: MonthlyCostCalculationParams
  ): Observable<MonthlyCostInfo> {
    let headersWithPin;

    if (this.cookieHasPin()) {
      headersWithPin = { ...this.headers, pin: this.getPin() };
    }

    return this.http.post<MonthlyCostInfo>(
      `${this.apiUrl}/calculate`,
      payload,
      {
        headers: headersWithPin || this.headers,
      }
    );
  }

  storePinInCookie(pin: string): void {
    // `Lax` needed because of Chrome's `samesite` cookie changes -- more info:
    // https://www.chromestatus.com/feature/5088147346030592
    // https://www.chromestatus.com/feature/5633521622188032
    this.cookie.set(
      this.cookieName,
      pin,
      this.cookieExpirationTime,
      undefined,
      undefined,
      undefined,
      'Lax'
    );
  }

  getPin(): string {
    return this.cookie.get(this.cookieName);
  }

  cookieHasPin(): boolean {
    return this.cookie.check(this.cookieName);
  }

  deleteCookie() {
    // `Lax` needed because of Chrome's `samesite` cookie changes -- more info:
    // https://www.chromestatus.com/feature/5088147346030592
    // https://www.chromestatus.com/feature/5633521622188032
    this.cookie.delete(this.cookieName, undefined, undefined, undefined, 'Lax');
  }

  logout(): Observable<boolean> {
    this.deleteCookie();
    return of(true);
  }
}
